import React from 'react';
import { Ellipsis } from '@gravity-ui/icons';
import { DropdownMenu, Icon, Popup } from '@gravity-ui/uikit';
import './floating.css';
export const TableCellFloatingButton = ({ dom, actions }) => {
    if (!dom) {
        return null;
    }
    return (React.createElement(Popup, { open: true, keepMounted: false, hasArrow: false, anchorRef: { current: dom }, offset: [2, -12], placement: "left-start" },
        React.createElement(DropdownMenu, { icon: React.createElement(Icon, { data: Ellipsis, size: 12, className: "table-cell-floating-icon" }), defaultSwitcherClassName: "table-cell-floating-button", items: actions.map(buildMenuItem) })));
};
TableCellFloatingButton.displayName = 'TableCellFloatingButton';
function buildMenuItem(floatingAction) {
    if (Array.isArray(floatingAction)) {
        // @ts-expect-error
        return floatingAction.map(buildMenuItem);
    }
    const { action, text } = floatingAction;
    const active = action.isActive();
    const disabled = !active && !action.isEnable();
    return {
        text,
        action: () => action.run(),
        active,
        disabled,
    };
}
